export default __webpack_public_path__ + "static/1convo-logo-6170c78dfc8d523fe36cc130c4b4c7a0.svg";